import { StyledImg } from "./Logo.styles";
import LogoImg from "../../assets/images/logo.png";

const Logo = () => {
  return <StyledImg src={LogoImg} alt="Logo" />;
};

export default Logo;
